import { NGS_READS_PILEUP_DENSITY } from "../../../settings/settings.js";

export const DEFAULT_NGS_LANES_COUNT = 30;
export const CIGAR_REGEXP = /(\d+)(\w)/g;
export const NGS_READS_SHAPE_HEIGHT = {
  [NGS_READS_PILEUP_DENSITY.COMPACT]: 1,
  [NGS_READS_PILEUP_DENSITY.MEDIUM]: 5,
  [NGS_READS_PILEUP_DENSITY.LARGE]: 13,
};

export const NGS_LANES_GAP = {
  [NGS_READS_PILEUP_DENSITY.COMPACT]: 0,
  [NGS_READS_PILEUP_DENSITY.MEDIUM]: 1,
  [NGS_READS_PILEUP_DENSITY.LARGE]: 2,
};

export const BED_SHAPE_HEIGHT = 13;
export const BED_LANES_GAP = 2;
